import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";
import defaultMigration from "../../defaultMigration";

export const minutes:SchemaTableOptions = {
    name:<string> 'minutes',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
		{ column: "cases_id", value: "INTEGER UNSIGNED" },
        { column: "content", value: "LONGTEXT NOT NULL" },
		{ column: "encoded_by", value: "INTEGER UNSIGNED" },
		{ column: "action", value: "INT UNSIGNED" },
        ...defaultMigration
    ]
}